import FormInputComponent from "@via/components/inputs/form-input-component";
import Modal from "@via/components/modal.tsx";
import { type FC, useEffect } from "react";
import { requiredValidation } from "@via/utils/form-validators.tsx";
import { useForm } from "react-hook-form";

interface AddNewColumnModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  spreadsheetColumn:
    | {
        columnIndex: number;
        columns: string[];
        insertPosition?: "left" | "right";
      }
    | undefined;
  submitSpreadsheetColumn: (updatedColumnName) => void;
}

const AddNewColumnModal: FC<AddNewColumnModalProps> = ({
  open,
  setOpen,
  spreadsheetColumn,
  submitSpreadsheetColumn,
}) => {
  const { control, handleSubmit, reset } = useForm({
    mode: "onChange",
    defaultValues: {
      name: "",
    },
  });

  useEffect(() => {
    reset({
      name: "",
    });
  }, [spreadsheetColumn, reset]);

  // Resolving true hands the close to Modal, and an empty name resolves false so
  // the dialog stays open on its required error. The parent used to close it from
  // inside submitSpreadsheetColumn, while this handler never settled at all.
  const handleConfirmModal = async (): Promise<boolean> => {
    let saved = false;
    await handleSubmit((payload: { name: string }) => {
      submitSpreadsheetColumn(payload.name);
      saved = true;
    })();
    return saved;
  };

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      title="Add Column"
      confirmText="Save"
      onConfirm={handleConfirmModal}>
      <form onSubmit={e => e.preventDefault()}>
        <div className="my-5">
          <FormInputComponent
            name="name"
            label="Column Name"
            showRequiredField
            control={control}
            validations={requiredValidation("Column Name")}
          />
        </div>
      </form>
    </Modal>
  );
};

export default AddNewColumnModal;
